export const findCachedValueByActionIdentifier = (
    cachedValuesArray = [],
    actionIdentifier
) => {
    return (
        cachedValuesArray.filter(v => v.actionIdentifier === actionIdentifier)[0] || {}
    ).title;
};

export const getCachedFullName = state => {
    return state.cachedFormData.fullName
        ? `${state.cachedFormData.fullName.split(' ')[0]} ${state.cachedFormData.fullName.split(' ').pop()}` //eslint-disable-line
        : state.cachedFormData.firstName && state.cachedFormData.lastName
        ? `${state.cachedFormData.firstName} ${state.cachedFormData.lastName}`
        : ``;
};

export const getCachedFirstName = state => {
    return state.cachedFormData.firstName
        ? state.cachedFormData.firstName
        : state.cachedFormData.fullName
        ? state.cachedFormData.fullName.split(' ')[0]
        : ``;
};
export const getCachedMiddleName = state => {
    if (state.cachedFormData.middleName) {
        return state.cachedFormData.middleName;
    } else if (
        state.cachedFormData.fullName &&
        state.cachedFormData.fullName.split(' ').length > 2
    ) {
        return state.cachedFormData.fullName.split(' ')[1];
    }
};
export const getCachedLastName = state => {
    return state.cachedFormData.lastName
        ? state.cachedFormData.lastName
        : state.cachedFormData.fullName
        ? state.cachedFormData.fullName.split(' ').pop()
        : ``;
};
